import { render, staticRenderFns } from "./tareasGantt.vue?vue&type=template&id=86dba1e0&scoped=true&"
import script from "./tareasGantt.vue?vue&type=script&lang=ts&"
export * from "./tareasGantt.vue?vue&type=script&lang=ts&"
import style0 from "./tareasGantt.vue?vue&type=style&index=0&id=86dba1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dba1e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VDialog,VSpacer,VToolbar})
